import { gql } from '@apollo/client';

export const AcknowledgeNotificationMutation = gql`
  mutation AcknowledgeNotification($type: NotificationType!, $interval: Int) {
    acknowledgeNotification(input: { type: $type, interval: $interval }) {
      errCode
      errDesc
      acknowledgedAt
    }
  }
`;
